import clsx from "clsx";
import React from "react";

import Dialog from "@material-ui/core/Dialog";

import { EModalConfirmationTypes } from "interfaces/VetExamState";
import { checkTypeModal } from "../helper";
import VetExamModalActions from "./VetExamModalActions/VetExamModalActions";
import VetExamModalContent from "./VetExamModalContent/VetExamModalContent";
import VetExamModalTitle from "./VetExamModalTitle/VetExamModalTitle";

import useStyles from "./styles";

interface IProps {
  type: EModalConfirmationTypes;
  onCloseModal: (shouldCloseExamForm?: boolean) => void;
  closeVetExamSavingState?: () => void;
  resetExam?: () => void;
  discardExam?: () => void;
  horseName?: string;
}

const VetExamModal = (props: IProps) => {
  const { type, horseName, ...actionProps } = props;

  const classes = useStyles();

  const { isPauseOrCloseModal, isResetModal, isExamEditInProgressModal } =
    checkTypeModal(type);

  const handleCloseModal = () => {
    actionProps.onCloseModal();
  };

  return (
    <Dialog
      className={clsx(classes.modal, {
        twoButtonDialog: isResetModal || isExamEditInProgressModal,
        threeButtonDialog: isPauseOrCloseModal
      })}
      open={true}
      onClose={handleCloseModal}
    >
      <VetExamModalTitle type={type} />

      <VetExamModalContent type={type} horseName={horseName} />

      <VetExamModalActions type={type} {...actionProps} />
    </Dialog>
  );
};

export default VetExamModal;
